import { gql } from "@apollo/client";

export type Role = {
  __typename: 'Role';
  id: number;
  name: string;
  data: boolean;
  dashboards: string[];
};

// Delegate for using existing API endpoint and types. For reference: `apps/web-app/src/containers/RolesContainer/graphql.ts`
export type RoleResponse = Pick<Role, 'id' | 'name' | 'data' | 'dashboards'> & {
  __typename: 'Role';
};

export type RoleBaseResponse = Pick<RoleResponse, '__typename' | 'id' | 'name'>;
export type RoleMetadataResponse = Pick<RoleResponse, 'data'>;
export type RoleDetailResponse = Pick<RoleResponse, 'dashboards'>;

export const ROLE_BASE_FRAGMENT = gql`
  fragment RoleBaseFragment on Role {
    __typename
    id
    name
  }
`;

export const ROLE_METADATA_FRAGMENT = gql`
  fragment RoleMetadataFragment on Role {
    data
  }
`;

export const ROLE_DETAIL_FRAGMENT = gql`
  fragment RoleDetailFragment on Role {
    dashboards
  }
`;

export const ROLE_FRAGMENT = gql`
  fragment RoleFragment on Role {
    ...RoleBaseFragment
    ...RoleMetadataFragment
    ...RoleDetailFragment
  }
  ${ROLE_BASE_FRAGMENT}
  ${ROLE_DETAIL_FRAGMENT}
  ${ROLE_METADATA_FRAGMENT}
`;
